<template>
  <div class="grid" :class="style">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'BaseGrid',
  props: {
    columns: {
      type: Number,
      default: 4
    }
  },
  computed: {
    style () {
      return 'grid-cols-1 sm:grid-cols-' + Math.ceil(this.columns / 3) + ' md:grid-cols-' + Math.ceil(this.columns / 2) + ' lg:grid-cols-' + Math.floor(this.columns - 1) + ' xl:grid-cols-' + this.columns
    }
  }
}
</script>

<style scoped lang="scss">
</style>
